/**
 * Breadcrumbs — accessible breadcrumb navigation component.
 *
 * Uses <nav>, <ol>, and aria-label for screen reader support.
 * The last item renders as plain text (current page); all others are Links.
 */

import { Link } from "react-router-dom";

export interface BreadcrumbItem {
  label: string;
  /** If omitted, the item is rendered as plain text (current page). */
  to?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  if (items.length === 0) return null;

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol className="breadcrumbs__list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={index} className="breadcrumbs__item">
              {index > 0 && (
                <span className="breadcrumbs__separator" aria-hidden="true">
                  ›
                </span>
              )}
              {isLast || !item.to ? (
                <span className="breadcrumbs__current" aria-current="page">
                  {item.label}
                </span>
              ) : (
                <Link className="breadcrumbs__link" to={item.to}>
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
